import { useState } from 'react';
import {
  Avatar, ButtonBase, Chip, Divider, ListItemIcon, ListItemText, Menu, MenuItem, SvgIcon, Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';

import { fotoDe } from '../common/imparte';
import { CONTADOR, useMenuUsuario } from './menuUsuario';

// Tu foto y tu nombre, arriba a la derecha en la computadora: abren tu menú, con las mismas opciones que el lateral del celular
const MenuAvatar = () => {
  const user = useSelector(state => state.user.user);
  const navigate = useNavigate();
  const [ancla, setAncla] = useState(null);
  const abierto = Boolean(ancla);
  const { opciones, salir } = useMenuUsuario(abierto);

  const irA = (destino) => () => {
    setAncla(null);
    navigate(destino);
  };

  return (
    <>
      <ButtonBase
        aria-label={`Menú de ${user.name}`}
        aria-haspopup="menu"
        aria-expanded={abierto ? 'true' : undefined}
        aria-controls={abierto ? 'menu-usuario' : undefined}
        onClick={(e) => setAncla(e.currentTarget)}
        sx={{ minWidth: 0, borderRadius: 2, pr: 0.5, '&:hover': { bgcolor: 'sutil' } }}
      >
        <Avatar src={fotoDe(user, 'w_55,h_55,c_fill') || undefined} sx={{ width: 55, height: 55 }} />
        {/* Un nombre largo se corta con «…» (completo al pasar el mouse) y no empuja al buscador */}
        <Typography component="span" noWrap title={user.name}
          sx={{ minWidth: 0, maxWidth: 140, ml: 2, fontSize: 16, fontWeight: 500, lineHeight: '24px', textTransform: 'capitalize' }}>
          {user.name}
        </Typography>
        <ExpandMoreIcon sx={{ ml: 0.5, color: 'text.secondary' }} />
      </ButtonBase>

      <Menu
        id="menu-usuario"
        anchorEl={ancla}
        open={abierto}
        onClose={() => setAncla(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { mt: 1, minWidth: 260, borderRadius: 2 } } }}
      >
        {opciones.map((item) => (
          <MenuItem key={item.click} selected={item.activo} onClick={irA(item.destino)}>
            <ListItemIcon><SvgIcon component={item.iconName} fontSize="small" /></ListItemIcon>
            <ListItemText primary={item.nombre} />
            {item.contador > 0 && <Chip size="small" label={item.contador} sx={CONTADOR} />}
          </MenuItem>
        ))}
        <Divider />
        <MenuItem onClick={() => { setAncla(null); salir(); }}>
          <ListItemIcon><ExitToAppOutlinedIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="Cerrar sesión" />
        </MenuItem>
      </Menu>
    </>
  );
};

export default MenuAvatar;
